import exquraWordmark from '../../assets/branding/exqura-wordmark.png';

const DEFAULT_SUPPORT_LINKS = [
  { label: "Help Center", href: "#" },
  { label: "Contact Us", href: "#" },
  { label: "FAQs", href: "#" },
  { label: "Cancellation Policy", href: "#" },
];

const DEFAULT_COMPANY_LINKS = [
  { label: "About Us", href: "#" },
  { label: "Careers", href: "#" },
  { label: "Terms & Conditions", href: "#" },
  { label: "Privacy Policy", href: "#" },
];

export default function ExquraFooter({ fields = {} }) {
  const {
    brandBlurb = "Your premier concierge for golfing experiences across the world's finest courses. Book exclusive tee times in seconds.",
    supportLinks = DEFAULT_SUPPORT_LINKS,
    companyLinks = DEFAULT_COMPANY_LINKS,
    instagramUrl = "https://instagram.com/exqura",
    facebookUrl = "https://facebook.com/exqura",
    copyrightText = "© 2026 Exqura Golf & Experiences. All rights reserved.",
  } = fields;

  return (
    <footer className="bg-[#0B2421] text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-3">
              <img src={exquraWordmark} alt="Exqura" className="h-5 w-auto" />
              <span className="text-white/80 font-light text-lg">GOLF & EXPERIENCES</span>
            </div>
            <p className="text-white/50 text-sm leading-relaxed whitespace-pre-line">
              {brandBlurb}
            </p>
          </div>

          {/* Support */}
          <div>
            <h4 className="font-bold text-sm tracking-widest uppercase text-[#D4AF37] mb-4">
              Support
            </h4>
            <ul className="space-y-3">
              {supportLinks.map((link, i) => (
                <li key={i}>
                  <a
                    href={link.href}
                    className="text-white/60 hover:text-white text-sm transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-bold text-sm tracking-widest uppercase text-[#D4AF37] mb-4">
              Company
            </h4>
            <ul className="space-y-3">
              {companyLinks.map((link, i) => (
                <li key={i}>
                  <a
                    href={link.href}
                    className="text-white/60 hover:text-white text-sm transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Socials + App Download */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-6 mt-10 pt-8 border-t border-white/10">
          <div className="flex items-center gap-4">
            <span className="text-white/50 text-sm font-medium">Our Socials</span>
            <div className="flex items-center gap-3">
              <a href={instagramUrl} target="_blank" rel="noopener noreferrer"
                className="w-9 h-9 rounded-full bg-white/10 border border-white/20 flex items-center justify-center hover:bg-[#D4AF37] hover:border-[#D4AF37] transition-colors">
                <img src="https://cdn.simpleicons.org/instagram/ffffff" alt="Instagram" className="w-4 h-4" />
              </a>
              <a href={facebookUrl} target="_blank" rel="noopener noreferrer"
                className="w-9 h-9 rounded-full bg-white/10 border border-white/20 flex items-center justify-center hover:bg-[#D4AF37] hover:border-[#D4AF37] transition-colors">
                <img src="https://cdn.simpleicons.org/facebook/ffffff" alt="Facebook" className="w-4 h-4" />
              </a>
            </div>
          </div>

          <div className="flex items-center gap-4">
            <span className="text-white/50 text-sm font-medium">Download the App</span>
            <div className="flex items-center gap-3">
              <a href="https://apps.apple.com" target="_blank" rel="noopener noreferrer">
                <img src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg" alt="App Store" className="h-8" />
              </a>
              <a href="https://play.google.com" target="_blank" rel="noopener noreferrer">
                <img src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png" alt="Google Play" className="h-[46px] -my-2" />
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-6 pt-4 border-t border-white/10">
          <p className="text-white/40 text-xs sm:text-sm">
            {copyrightText}
          </p>
        </div>
      </div>
    </footer>
  );
}
